import React from "react"
import { Box, Flex } from "@chakra-ui/react"
import { Link, Container, MotionBox, Text } from "@src/shared/components"
import { StaticImage } from "gatsby-plugin-image"

export const PageLayout: React.FC<{ centerLogo?: boolean }> = ({
  children,
  centerLogo,
}) => {
  return (
    <Flex
      minHeight="100vh"
      direction="column"
      bg="alpha.neutralLight"
      justifyContent="space-between"
      overflow="auto"
    >
      <Box as="header" py={8} role="banner">
        <Container>
          <MotionBox
            alignItems="center"
            display="flex"
            justifyContent={centerLogo ? "center" : "flex-start"}
            width="100%"
          >
            <Link href="/">
              <Box>
                <StaticImage
                  src="../../../../assets/images/ohema/logo.png"
                  alt="Ohema logo"
                  width={150}
                />
              </Box>
            </Link>
          </MotionBox>
        </Container>
      </Box>
      {children}
      <Box as="footer" role="contentinfo" py={6} mt={6}>
        <Container>
          <Flex
            justify="space-between"
            direction={{ sm: "column", md: "row" }}
            textAlign={{ sm: "center", md: "initial" }}
          >
            <Flex direction={{ sm: "column", md: "row" }}>
              <Link
                href="/policy/terms-of-service"
                mb={{ sm: 2, md: 0 }}
                mr={{ md: 4 }}
              >
                <Text type="legal">Terms of Service</Text>
              </Link>
              <Link
                href="/policy/privacy-policy"
                mb={{ sm: 2, md: 0 }}
                mr={{ md: 4 }}
              >
                <Text type="legal">Privacy Policy</Text>
              </Link>
              <Link href="/policy/return-policy" mb={{ sm: 2, md: 0 }}>
                <Text type="legal">Refund Policy</Text>
              </Link>
            </Flex>
            <Text type="legal" mt={{ sm: 4, md: 0 }}>
              © Ohema 2022. All rights reserved
            </Text>
          </Flex>
        </Container>
      </Box>
    </Flex>
  )
}
